<template>
  <section class="content">
    <h2 class="subtitle">
      Digital Signature and Confirmation
    </h2>
    <p>By checking the box below, I affirm that:</p>
    <ul>
      <li v-for="field in affirmationPoints" :key="field">{{field}}</li>
    </ul>
    <label class="checkbox has-text-weight-semibold">
        <input type="checkbox" name="affirmation" required="required">
        I Affirm.
    </label>
  </section>
</template>

<script>
export default {
  computed: {
    affirmationPoints() {
      return this.$store.state.affirmation_points ? this.$store.state.affirmation_points : ['This is my one and only submission.'];
    },
  },
};
</script>
